import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';

const CourseCard = ({ course }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleCardClick = () => {
    if (!isFlipped) {
      setIsFlipped(true);
      setTimeout(() => {
        setIsExpanded(true);
      }, 400); // half of the flip duration
    }
  };

  const handleCloseClick = (e) => {
    e.stopPropagation();
    setIsFlipped(false);
    setTimeout(() => {
      setIsExpanded(false);
    }, 400); // half of the flip duration
  };

  return (
    <div className={`course-card-container ${isExpanded ? 'expanded' : ''}`} onClick={isExpanded ? handleCloseClick : handleCardClick}>
      <div className={`course-card ${isFlipped ? 'flipped' : ''}`}>
        <div className="card-face card-front">
          <h3>{course.title}</h3>
          <p><strong>Overview:</strong> {course.overview}</p>
          <p><strong>Duration:</strong> {course.duration}</p>
          <p><strong>Audience:</strong> {course.audience}</p>
          <p><strong>Objective:</strong> {course.objective}</p>
          <p><strong>Delivery Mode:</strong> {course.delivery_mode}</p>
          <p><strong>Course Format:</strong> {course.course_format}</p>
          <p><strong>Pre-requisites:</strong> {course.pre_requisites}</p>
          <p><strong>Cost per Attendee:</strong> {course.per_person_cost}</p>
          <div className="card-tags">
            {course.tags && course.tags.map(tag => (
              <span key={tag} className="tag">{tag}</span>
            ))}
          </div>
        </div>
        <div className="card-face card-back">
          <button className="close-button" onClick={handleCloseClick}>X</button>
          <ReactMarkdown>{course.content}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
